import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CreateUpdateSuite from './CreateUpdateSuite';

const SuiteTypesPage = () => {
  const [suiteTypes, setSuiteTypes] = useState([]);
  const [editingSuite, setEditingSuite] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');

  const API_URL = 'https://apitop.topranohotelandlounge.com/api/suite-types';

  const fetchSuites = async () => {
    try {
      const res = await axios.get(API_URL);
      setSuiteTypes(res.data);
    } catch (error) {
      console.error('Error fetching suite types:', error);
      setMessage('Failed to load suite types');
    }
  };

  useEffect(() => {
    fetchSuites();
  }, []);

  const handleCreateOrUpdate = async (formData) => {
    try {
      setIsLoading(true);
      setMessage('');

      if (editingSuite) {
        const res = await axios.put(`${API_URL}/${editingSuite._id}`, formData);
        setMessage(res.data.message || 'Suite updated successfully');
      } else {
        const res = await axios.post(API_URL, formData);
        setMessage(res.data.message || 'Suite created successfully');
      }

      setEditingSuite(null);
      await fetchSuites();
    } catch (error) {
      console.error('Error saving suite type:', error);
      setMessage(
        error.response?.data?.message || 'Something went wrong while saving suite type'
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = (suite) => {
    setEditingSuite(suite);
    setMessage('');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleCancelEdit = () => {
    setEditingSuite(null);
    setMessage('');
  };

  return (
    <div className="suite-container">
      {message && <p className="message">{message}</p>}

      <CreateUpdateSuite
        initialData={editingSuite}
        onSubmit={handleCreateOrUpdate}
        onCancel={handleCancelEdit}
        isLoading={isLoading}
      />

      <div className="suite-list-section">
        <div className="suite-topbar">
          <h2>All Suite Types</h2>
        </div>

        <div className="suite-list">
          {suiteTypes.map((suite) => (
            <div key={suite._id} className="suite-card">
              <h3>{suite.name}</h3>
              <p>{suite.description}</p>
              <p><strong>Price:</strong> ₦{suite.basePrice}</p>
              <p><strong>Capacity:</strong> {suite.capacity}</p>
              <p><strong>Size:</strong> {suite.size}</p>
              <p><strong>Total Rooms:</strong> {suite.totalRooms}</p>
              <p><strong>Available Rooms:</strong> {suite.availableRooms}</p>

              <button onClick={() => handleEdit(suite)}>
                Edit Suite
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SuiteTypesPage;